import { render, staticRenderFns } from "./LoginInfoModal.vue?vue&type=template&id=1f6856f3&scoped=true"
import script from "./LoginInfoModal.vue?vue&type=script&lang=js"
export * from "./LoginInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6856f3",
  null
  
)

export default component.exports